import { Box, Chip, FormHelperText, OutlinedInput } from '@mui/material'
import React from 'react'
import { Control, Controller } from 'react-hook-form'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
}

const icon = <CheckBoxOutlineBlankIcon fontSize='small' />
const checkedIcon = <CheckBoxIcon fontSize='small' />

type InputSelectProps = {
  label: string
  name: string
  options: ItemOption[]
  control: Control<any>
}

export type ItemOption = {
  value: string
  label: string
}

export const itemOptionsInit: ItemOption = {
  value: '0',
  label: 'Selecione',
}

export const InputMultiSelect: React.FC<InputSelectProps> = ({ label, name, options, control }) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <FormControl size='small' sx={{ width: '100%' }} error={!!error}>
          <InputLabel>{label}</InputLabel>
          <Select
            labelId='demo-multiple-chip-label'
            id='demo-multiple-chip'
            multiple
            value={value}
            onChange={onChange}
            input={<OutlinedInput id='select-multiple-chip' label={label} />}
            renderValue={(selected) => (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                {selected.map((value: string) => {
                  const chipLabel = options.find((item) => item.value === value)
                  return chipLabel && <Chip key={value} label={chipLabel.label} size='small' />
                })}
              </Box>
            )}
            MenuProps={MenuProps}
          >
            {options.map((item) => (
              <MenuItem key={item.value} value={item.value}>
                {item.label}
              </MenuItem>
            ))}
          </Select>
          {error && error.message && <FormHelperText>{error.message}</FormHelperText>}
        </FormControl>
      )}
    />
  )
}
